import { createRoot } from "react-dom/client"

import App from "./components/App"
import GlobalStyle from "../shared/components/GlobalStyle"
import { ContentProvider } from "../shared/components/ContentProvider"

async function start() {
  const urlParams = new URLSearchParams(window.location.search)
  const container = document.getElementById("app")
  const root = createRoot(container)

  const content = await (await fetch("../content/mobileScopes.json")).json()

  const documentHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty("--doc-height", `${window.innerHeight}px`)
  }
  window.addEventListener("resize", documentHeight)
  documentHeight()

  root.render(
    <ContentProvider content={{ ...content, urlParams }}>
      <GlobalStyle />
      <App />
    </ContentProvider>
  )
}

start()
